var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ faded: _vm.route && _vm.route === 'taskHub' }},[_c('router-link',{staticClass:"nav-link",class:[
      _vm.isRouteActive ? 'active' : '',
      _vm.barClosed ? 'shrink-container' : 'expand-container',
      _vm.route === 'logout' ? 'logout' : '',
    ],attrs:{"to":{ name: _vm.route }}},[_vm._t("default"),_c('p',{staticClass:"text-link",class:[_vm.barClosed ? 'hiding-text' : 'show-text']},[_vm._v(" "+_vm._s(_vm.routeLabel)+" ")])],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }